/**
 * ServiceMetadataStore
 * Extends the BaseStore for managing ServiceMetadata.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { ServiceListItemInterface } from '@sah/Classes/ServiceMetadata';

class ServiceMetadataStore extends BaseStore<ServiceListItemInterface> {}

export default new ServiceMetadataStore();
